export enum Availability {
    NotAvailable,
    Available
}